export enum BlogThumbnailType {
    Simple,
    Gallery,
    Image,
    Quote,
    Video
}